import {baseUrl, cookieName} from "../store/stores";
import {Cookie} from "../security/Cookie";
import {push} from "svelte-spa-router";

class ApiCall {

    private cookieName_value: string = '';
    private baseUrl_value: string = '';

    constructor() {
        cookieName.subscribe(value => {
            this.cookieName_value = value;
        });

        baseUrl.subscribe(value => {
            this.baseUrl_value = value;
        });
    }

    async postRequest<Type>(request: string, data: Type): Promise<any>  {

        try {
            const rawResponse = await fetch(this.baseUrl_value + request, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            })

            return await rawResponse.json();
        }
        catch (e) {
            push('/erreur500')
        }
    }

    async authenticatedPostRequest<Type>(request: string, data: Type): Promise<any> {

        const cookie = new Cookie();
        let token = cookie.getCookie(this.cookieName_value);

        if (typeof token === 'string') {

            try {
                const rawResponse = await fetch(this.baseUrl_value + request, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    },
                    body: JSON.stringify(data)
                })
                return await rawResponse.json();
            }
            catch (e) {
                push('/erreur500')
            }
        }
        else {
            push('/erreur401')
        }
    }

    async downloadPostRequest<Type>(request: string, data: Type): Promise<any> {

        const cookie = new Cookie();
        let token = cookie.getCookie(this.cookieName_value);

        if (typeof token === 'string') {
            try {
                const rawResponse = await fetch(this.baseUrl_value + request, {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })

                return await rawResponse
            }
            catch (e) {
                push('/erreur500')
            }
        }
        else {
            push('/erreur401')
        }
    }
}

export {ApiCall}